import React from 'react'
import { withPrefix } from 'gatsby'
import { Certificate } from '../../../../../svg/certificate'
import { Procedure } from '../../../../../svg/procedure'
import s from './index.module.css'

const ComoSeComponeMiAporteObligatorio = () => {
  return (
    <div className={'containerWrap'}>
      <div className="c-gray--4 center tw-mb-12 tw-mb-12@lg">
        <h3 className="font-family-secondary fw-7 tw-f-20 tw-f-24@lg tw-m-0">
          ¿Cómo se compone mi aporte obligatorio?
        </h3>
      </div>

      <div className={`flex@lg`}>
        <div
          className={`flex direction-column justify-around w-100 w-40@lg border border-2 border-orange-0 brad-4 tw-pt-10 tw-px-8 tw-px-12@lg tw-mb-10 tw-mb-0@lg`}
        >
          <div className={`tw-mb-2 tw-mb-5@lg center`}>
            <p className="font-family-secondary tw-f-20 tw-f-24@lg">
              <strong>
                Tu aporte obligatorio se descuenta de tu <br></br>
                <span className="c-orange-0">
                  sueldo y se compone en tres partes:
                </span>
              </strong>
            </p>
          </div>

          <div className="flex items-center justify-center">
            <div className="flex justify-center ml-auto mr-auto">
              <div className={`w-auto w-100@lg`}>
                <img
                  src={withPrefix('/images/woman-pointing.svg')}
                  alt="woman-pointing"
                  className={`${s.imagenBox10} ${s.objectFit}`}
                />
              </div>
            </div>
          </div>
        </div>

        <div
          className={`flex direction-column justify-around w-100 w-60@lg tw-pl-8@lg`}
        >
          <div className={`brad-4 shadow bg-white tw-p-8 tw-mb-4 bg-white`}>
            <Certificate fill="#00CCCC" className={'tw-mb-2'} />
            <div className="tw-mb-1 tw-mb-2@lg">
              <h4 className="font-family-secondary c-gray--4 fw-7 tw-f-16 tw-f-20@lg">
                Aporte a tu fondo
              </h4>
            </div>
            <div>
              <p className="font-family-primary c-gray--4 fw-0 tw-f-16 tw-f-16@lg">
                Este dinero va a tu cuenta personal en la AFP. Te pertenece sólo
                a ti y servirá para que recibas una pensión en el futuro.
                <br></br>
                Es el 10% de tu sueldo.
              </p>
            </div>
          </div>

          <div className={`brad-4 shadow bg-white tw-p-8 tw-mb-4 bg-white`}>
            <Procedure fill="#00CCCC" className={'tw-mb-2'} />
            <div className="tw-mb-1 tw-mb-2@lg">
              <h4 className="font-family-secondary c-gray--4 fw-7 tw-f-16 tw-f-20@lg">
                Seguro de invalidez, sobrevivencia y gastos de sepelio
              </h4>
            </div>
            <div>
              <p className="font-family-primary c-gray--4 fw-0 tw-f-16 tw-f-16@lg">
                Es un pago que te da derecho a tener un seguro, que te protege a
                ti en caso de invalidez o a tu familia si tú falleces.<br></br>
                Representa el 1.37% de tu sueldo.<br></br>
                Vigencia desde enero a diciembre 2025.
              </p>
            </div>
          </div>

          <div className={`brad-4 shadow bg-white tw-p-8 bg-white`}>
            <Procedure fill="#00CCCC" className={'tw-mb-2'} />
            <div>
              <h4 className="font-family-secondary c-gray--4 fw-7 tw-f-16 tw-f-20@lg">
                Comisión de la AFP
              </h4>
            </div>
            <div>
              <p className="font-family-primary c-gray--4 fw-0 tw-f-16 tw-f-16@lg">
                Es un porcentaje que te cobra la AFP por administrar tu fondo y
                que le permite invertir para que tu dinero obtenga rentabilidad.
                <br></br>
                El porcentaje depende de tu tipo de comisión.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ComoSeComponeMiAporteObligatorio
